import { SnippetsInput, SnippetsInputProps } from 'components/Wizards/Snippets/SnippetsInput/SnippetsInput'
import { useField, useFormikContext } from 'formik'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import { forwardRef } from 'react'

interface Props extends Omit<SnippetsInputProps, 'value' | 'onChange'> {
  name: string
  isLoading?: boolean
  rows?: number
}

export const SnippetsTextInput = forwardRef<HTMLInputElement, Props>(
  ({ name, isLoading = false, rows = 1, ...props }, fRef) => {
    const { status } = useFormikContext()
    const [field, meta, helpers] = useField(name)
    const { touched, error } = meta

    if (status === FormStatus.AutoFilling || isLoading) {
      return <TextFieldLoadingState lines={Math.max(1, rows - 1)} />
    }

    return (
      <SnippetsInput
        {...props}
        name={name}
        value={field.value}
        onChange={(text) => helpers.setValue(text)}
        size="lg"
        isValid={touched ? !error : true}
        ref={fRef}
      />
    )
  },
)
